import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-iceberg')
export class ObiIceberg extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9 5L7.5 3.5L4.56846 9.23638C4.05611 9.4114 3.52806 9.50404 3 9.50404H2V11.504H3C4.04242 11.504 5.07761 11.2395 6 10.754C7.89 11.754 10.11 11.754 12 10.754C13.89 11.754 16.11 11.754 18 10.754C18.94 11.254 19.97 11.504 21 11.504H22V9.50404H21C20.517 9.50404 20.0344 9.4265 19.5635 9.27933L17 4L15 5.5L11.9999 1.5L9 5ZM7.89737 6.01869L6.48224 8.78778C6.66464 8.89388 6.85904 9.00145 6.98565 9.05598C8.27971 9.61426 9.71724 9.61467 11.0115 9.05721C11.3115 8.92801 12.0053 8.5 12.0053 8.5C12.0053 8.5 12.6885 8.92801 12.9885 9.05721C14.2809 9.61385 15.7161 9.61426 17.0086 9.05844C17.1609 8.99286 17.4152 8.85186 17.6288 8.72891L16.4451 6.2912L14.7 7.59999L11.9219 3.89594L9.08474 7.20606L7.89737 6.01869Z" fill="currentColor"/>
<path d="M19.9271 13.4305L15 20L14 19L12 22.5L4.95679 13.2558C5.3096 13.1648 5.65767 13.049 5.99914 12.9086C7.92764 13.7024 10.0714 13.7025 12 12.909C13.9279 13.7022 16.0709 13.7024 17.9989 12.9094C18.6224 13.1663 19.2703 13.3401 19.9271 13.4305Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9 5L7.5 3.5L4.56846 9.23638C4.05611 9.4114 3.52806 9.50404 3 9.50404H2V11.504H3C4.04242 11.504 5.07761 11.2395 6 10.754C7.89 11.754 10.11 11.754 12 10.754C13.89 11.754 16.11 11.754 18 10.754C18.94 11.254 19.97 11.504 21 11.504H22V9.50404H21C20.517 9.50404 20.0344 9.4265 19.5635 9.27933L17 4L15 5.5L11.9999 1.5L9 5ZM7.89737 6.01869L6.48224 8.78778C6.66464 8.89388 6.85904 9.00145 6.98565 9.05598C8.27971 9.61426 9.71724 9.61467 11.0115 9.05721C11.3115 8.92801 12.0053 8.5 12.0053 8.5C12.0053 8.5 12.6885 8.92801 12.9885 9.05721C14.2809 9.61385 15.7161 9.61426 17.0086 9.05844C17.1609 8.99286 17.4152 8.85186 17.6288 8.72891L16.4451 6.2912L14.7 7.59999L11.9219 3.89594L9.08474 7.20606L7.89737 6.01869Z" style="fill: var(--element-active-color)"/>
<path d="M19.9271 13.4305L15 20L14 19L12 22.5L4.95679 13.2558C5.3096 13.1648 5.65767 13.049 5.99914 12.9086C7.92764 13.7024 10.0714 13.7025 12 12.909C13.9279 13.7022 16.0709 13.7024 17.9989 12.9094C18.6224 13.1663 19.2703 13.3401 19.9271 13.4305Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-iceberg': ObiIceberg;
  }
}
